/* istanbul ignore file */
export { default } from './DownArrow';
